import { render, staticRenderFns } from "./TableModule.vue?vue&type=template&id=a90a430a"
import script from "./TableModule.vue?vue&type=script&lang=js"
export * from "./TableModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports